/* eslint-disable no-param-reassign */
import axios from 'axios'
// import Vue from 'vue'
const baseURL = process.env.VUE_APP_BASE_URL

export default {
   namespaced: true,
   state: {
      data: [],
      countTotal: 0,
      countAll: 0,
      countAllDetail: 0,
      current: 0,
      success: 0,
      failed: 0,
      runningState: false,
      cancelToken: '',
   },
   getters: {},
   actions: {
      async login({ rootState, state }) {
         rootState.isLoading = true
         return axios
            .post(
               `${baseURL}oss/scrap/login`,
               {},
               {
                  cancelToken: state.cancelToken,
               },
            )
            .then(
               response => {
                  rootState.isLoading = false
                  return Promise.resolve(response.data)
               },
               () => {
                  rootState.isLoading = false
                  return Promise.reject()
               },
            )
      },
      async runScrapList({ rootState, state }, page) {
         rootState.isLoading = true
         return axios
            .post(
               `${baseURL}oss/lkpm/non-umk/scrap/updatelist`,
               { page },
               {
                  cancelToken: state.cancelToken,
               },
            )
            .then(
               response => {
                  rootState.isLoading = false
                  return Promise.resolve(response.data)
               },
               () => {
                  rootState.isLoading = false
                  return Promise.reject()
               },
            )
      },
      async getData({ commit, rootState }) {
         rootState.isLoading = true
         return await axios.get(`${baseURL}oss/lkpm/non-umk/scrap/list`).then(
            response => {
               const items = Array.isArray(response.data.items) ? response.data.items : Array.isArray(response.data) ? response.data : []
               commit('SET_DATA', items)
               commit('SET_COUNT', items)
               commit('SET_COUNT_TOTAL', response.data.total)
               rootState.isLoading = false
               return Promise.resolve(items)
            },
            () => {
               rootState.isLoading = false
               return Promise.reject()
            },
         )
      },
      async getDataError({ commit, rootState }) {
         rootState.isLoading = true
         return await axios.get(`${baseURL}oss/lkpm/non-umk/scrap/error`).then(
            response => {
               const items = Array.isArray(response.data.items) ? response.data.items : Array.isArray(response.data) ? response.data : []
               commit('SET_DATA', items)
               commit('SET_COUNT', items)
               commit('SET_COUNT_TOTAL', response.data.total)
               rootState.isLoading = false
               return Promise.resolve(items)
            },
            () => {
               rootState.isLoading = false
               return Promise.reject()
            },
         )
      },
      async runScrap({ commit, rootState, state }, idLaporan) {
         rootState.isLoading = true
         const param = { id_laporan: idLaporan }
         return await axios
            .post(`${baseURL}oss/lkpm/non-umk/scrap/download`, param, {
               cancelToken: state.cancelToken,
            })
            .then(
               data => {
                  commit('SET_SUCCESS')
                  commit('NEXT')
                  rootState.isLoading = false
                  return Promise.resolve(data)
               },
               error => {
                  commit('SET_FAILED')
                  commit('NEXT')
                  rootState.isLoading = false
                  return Promise.resolve(error)
               },
            )
      },
   },
   mutations: {
      SET_DATA(state, data) {
         state.data = data
      },
      SET_COUNT(state, data) {
         state.countAll = data.length
      },
      SET_COUNT_DETAIL(state, data) {
         state.countAllDetail = data
      },
      SET_COUNT_TOTAL(state, data) {
         state.countTotal = data
      },
      SET_CURRENT(state, data) {
         state.current = data
      },
      SET_SUCCESS(state) {
         state.success += 1
      },
      SET_FAILED(state) {
         state.failed += 1
      },
      SET_STATE(state, data) {
         state.runningState = data
      },
      SET_CANCEL_TOKEN(state, data) {
         state.cancelToken = data
      },
      NEXT(state) {
         state.current += 1
      },
      SET_RESET(state) {
         state.current = 0
         state.success = 0
         state.failed = 0
      },
   },
}
